import type { DomainTreeItem } from '@/shared/types/domain';

import type { DomainHierarchyItem } from '@/entities/domain';
import { updateEntityDomains } from '@/entities/domain/api';

export const updateTagCategoryDomains = async (
  tagCategoryId: string,
  selectedDomainId: string | null,
  hierarchy: DomainHierarchyItem[],
  currentDomains: DomainTreeItem[]
): Promise<void> => {
  await updateEntityDomains(`/classifications/${tagCategoryId}`, selectedDomainId, hierarchy, currentDomains);
};
